<template>
	<div class="wrap">
		<!-- 自定义标签弹窗 -->
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>谈心谈话记录</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.query.type == 'edit'?'编辑谈心谈话':'新增谈心谈话'}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar">
						<el-button type="primary"
						size="small"
						@click="$router.go(-1)">返回</el-button>
					</div>
					<div class="addTitle">{{$route.query.type == 'edit'?'编辑谈心谈话':'新增谈心谈话'}}</div>
					<div class="addWrap">
						<el-form 
							label-position="center"
							label-width="80px"
							ref="formData" 
							:model="formData" 
							:rules="rules">
							<el-form-item class="form_item" label="谈话主题" prop="title">
								<el-input
									placeholder="请输入谈话主题"
									v-model="formData.title">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="谈话人" prop="uid1">
								<el-input
									placeholder="姓名 (职务) "
									v-model="formData.uid1">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="谈话对象" prop="dwid">
								  <el-cascader
									v-model='formData.dwid'
								    placeholder="请选择谈话对象"
								    :options="zzlist"
								    filterable></el-cascader>
							</el-form-item>
							<el-form-item class="form_item" label="时间" prop="day">
								<el-date-picker
									v-model="formData.day"
									type="date"
									placeholder="请选择时间"
									value-format="yyyy-MM-dd">
								</el-date-picker>
							</el-form-item>
							<el-form-item class="form_item" label="地点" prop="">
								<el-input
									placeholder="请输入地点"
									v-model="formData.address">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item fuwenben" style="padding-bottom: 70px;"  label="主要内容"  prop="">
								<quill-editor :options="$VueQuillEditor" ref="myTextEditor" v-model="formData.content" style="height:327px !important;width: 800px;"></quill-editor>
							</el-form-item>
							<el-form-item class="form_item" label="文件备案"  prop="">
								<el-upload
									:data="{token:$store.state.user.userinfo.token}"
									name="file"
									:action="$uploadFile"
									:show-file-list="false"
									:on-success="success1"
									:on-progress="uploadProcess"
									:before-upload="$limitFile">
									<el-button  type="primary">上传内容</el-button>
									<div class="tishi">支持图片，pdf、mp4文件，大小不得超过200M</div>
								</el-upload>
							</el-form-item>
							<div class="fileList" v-if="formData.files.length > 0">
								<div class="fileItem" v-for="(item,index) in formData.files">
									<div class="fileIcon" v-if="item.bsid == 8"><img src="@/assets/images/pdfBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 3"><img src="@/assets/images/videoBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 1"><img src="@/assets/images/pptBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 2"><img src="@/assets/images/imgbg.png" ></div>
									<div class="fileName">{{item.title}}</div>
									<div class="fileDel" title="删除" @click="delfile(index)"><i class="el-icon-delete"></i></div>
								</div>
							</div>
							<el-form-item class="form_item submit">
								<el-button type="primary" @click="submit('formData')">保存</el-button>
								<el-button @click="$router.go(-1)">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import txth_add from './mixins/txth_add'
	export default{
		mixins: [txth_add],
	}
</script>

<style lang="scss">
	.wrap{
		width: 100%;
		position: relative;
		color: $index_color;
		font-size: index_size1;
		.addTitle{
			width: 100%;
			border-bottom: 1px solid #DDE2EE;
			padding-bottom: 15px;
			margin: -40px 0 20px 0;
			font-size: 18px;
			color: #333333;
			font-weight: bold;
			width: 80%;
		}
		.el-input{
			width: 220px !important;
		}
		.addWrap{
			.form_item{
				width: 100%;
				margin-bottom: 15px;
				display: flex !important;
				align-items: flex-start !important;
				font-size: 14px;
				.fengmian{
					display: inline-block;
					vertical-align: bottom;
					height: 150px;
					margin-right: 10px;
					margin-left: 0;
					width: 223px;
				}
				.tishi{
					font-size: 12px;
					color: rgb(131, 138, 157);
					margin-top: 10px;
				}
				.el-upload{
					text-align: left !important;
				}
				.biaoqian{
					width: 500px;
					.el-tag {
						margin-right: 10px;
					}
				}
			}
			.el-form-item__content{
				margin-left: 0 !important;
			}
			.fuwenben{
				padding-bottom: 110px;
			}
			.submit{
				padding-left: 85px;
			}
			.el-form-item__error{
				position: relative !important;
				margin-left: 20px;
				line-height: 30px;
			}
			.fileList{
				width: 400px;
				margin-left: 65px;
				max-height: 400px;
				overflow-y: scroll;
				overflow-x: hidden;
				margin-bottom: 22px;
				overflow-y: scroll;
				box-sizing: border-box;
				.fileItem{
					width: 100%;
					border: 1px solid #ddd;
					padding: 10px 10px;
					height: 80px;
					margin-bottom: 15px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					.fileIcon{
						width: 50px;
						img{
							width: 100%;
						}
					}
					.fileName{
						margin-left: 10px;
						margin-right: 10px;
						width: 280px;
						line-height: 30px;
						height: 30px;
						overflow: hidden;
					}
					i{
						cursor: pointer;
					}
					i:hover{
						color: #BB0000;
					}
				}
			}
		}
	}
</style>
